module.exports = "#version 300 es\nprecision highp float;\n\n// The fragment shader used to render the background of the scene\n// Modify this to make your background more interesting\n\nout vec4 out_Col;\n\nvoid main() {\n  out_Col = vec4(164.0 / 255.0, 233.0 / 255.0, 1.0, 1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/flat-frag.glsl
// module id = 81
// module chunks = 0